/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Postgres RDS API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  AdditionalInfoV7Response,
  AdminRefVacuumV7Response,
  ApiResponseClusterDatabaseCmmRs,
  ApiResponseInt,
  ApiResponsePostgresqlParameterDetailRs,
  ApiResponseTopTransactionInfoResponse,
  CheckPointV7Response,
  FunctionDetailV7Response,
  FunctionSrcV7Response,
  GetV7PostgresDatabaseListParams,
  GetV7PostgresPaAdminReferenceByInstanceIdParams,
  GetV7PostgresPaCheckpointByInstanceIdParams,
  GetV7PostgresPaFunctionsByInstanceIdParams,
  GetV7PostgresPaFunctionsFuncsrcByInstanceIdParams,
  GetV7PostgresPaObjectInfoByInstanceIdParams,
  GetV7PostgresPaObjectNamesByInstanceIdParams,
  GetV7PostgresPaObjectRatioByInstanceIdParams,
  GetV7PostgresPaObjectTopByInstanceIdParams,
  GetV7PostgresPaObjectTrendByInstanceIdParams,
  GetV7PostgresPaObjects10minAgeByInstanceIdParams,
  GetV7PostgresPaObjects10minAnalyzeTimeByInstanceIdParams,
  GetV7PostgresPaObjects10minDeadTupleByInstanceIdParams,
  GetV7PostgresPaObjects10minScanCountByInstanceIdParams,
  GetV7PostgresPaObjects10minScanRatioByInstanceIdParams,
  GetV7PostgresPaObjects10minTablespaceSizeByInstanceIdParams,
  GetV7PostgresPaParameterDetailByInstanceIdAndParameterNameParams,
  GetV7PostgresPaParameterHistoryParams,
  GetV7PostgresPaRtmOverviewByInstanceIdParams,
  GetV7PostgresPaRtmReplicationByInstanceIdParams,
  GetV7PostgresPaSessionsParams,
  GetV7PostgresPaTopDiffStatisticsByInstanceIdParams,
  GetV7PostgresPaTopFunctionCallByInstanceIdParams,
  GetV7PostgresPaTopObjectScanByInstanceIdParams,
  GetV7PostgresPaTopSessionEventByInstanceIdParams,
  GetV7PostgresPaTopSessionSqlByInstanceIdParams,
  GetV7PostgresPaTrendLongActivebackendsByInstanceIdParams,
  GetV7PostgresPaTrendTopObjectSortByInstanceIdParams,
  GetV7PostgresPaVacuumByInstanceIdParams,
  GetV7PostgresPaVacuumingBackendsByInstanceIdParams,
  GetV7PostgresPaVacuumingBackendsSecondParams,
  GetV7PostgresSingleViewDatabaseSlowqueryParams,
  GetV7PostgresTopTrxInfoParams,
  LastParameterResponse,
  LongActiveBackendV7Response,
  MultiInstanceRequestBody,
  MultiOverviewV7Response,
  ObjectInfoV7Response,
  ObjectScanRatioV7Response,
  ObjectTrendV7Response,
  OverViewV7Response,
  ParameterResponse,
  PostV7PostgresPaActivebackendKillSessionByInstanceIdParams,
  PostV7PostgresPaOverviewParams,
  PostV7PostgresSqlPlanByInstanceIdParams,
  ReplicationInfoV7Response,
  SessionSearchListV7Response,
  SlowQueryListV7Response,
  SqlPlanOptionRequest,
  SqlPlanV7Response,
  TopDiffStatisticsV7Response,
  TopFunctionV7Response,
  TopObjectAnalyzeTimeV7Response,
  TopObjectListAgeV7Response,
  TopObjectListDeadTupleV7Response,
  TopObjectListScanCountV7Response,
  TopObjectListTableSpaceV7Response,
  TopObjectScanListV7Response,
  TopObjectTableScanRatioV7Response,
  TopObjectV7Response,
  TopSessionEventV7Response,
  TopSessionSqlV7Response,
  TrendTopObjectListV7Response,
  VacuumV7Response,
  VacuumingBackendV7Response,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary [Postgresql] : 클러스터 아이디로 하위 DB 목록을 가져오는 공통 API (싱글 인스턴스인 경우 자신 정보 리턴)
 */
export const getV7PostgresDatabaseList = (
  params: MaybeRef<GetV7PostgresDatabaseListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseClusterDatabaseCmmRs>(
    { url: `/api/v7/postgres/database-list`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7PostgresDatabaseListQueryKey = (
  params?: MaybeRef<GetV7PostgresDatabaseListParams>,
) => {
  return ['api', 'v7', 'postgres', 'database-list', ...(params ? [params] : [])] as const;
};

export const getGetV7PostgresDatabaseListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresDatabaseList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresDatabaseListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresDatabaseList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresDatabaseListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7PostgresDatabaseList>>> = ({
    signal,
  }) => getV7PostgresDatabaseList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresDatabaseList>>,
    TError,
    TData
  >;
};

export type GetV7PostgresDatabaseListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresDatabaseList>>
>;
export type GetV7PostgresDatabaseListQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql] : 클러스터 아이디로 하위 DB 목록을 가져오는 공통 API (싱글 인스턴스인 경우 자신 정보 리턴)
 */

export function useGetV7PostgresDatabaseList<
  TData = Awaited<ReturnType<typeof getV7PostgresDatabaseList>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresDatabaseListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresDatabaseList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresDatabaseListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [PostgreSQL] MultiView - Overview
 */
export const postV7PostgresPaOverview = (
  multiInstanceRequestBody: MaybeRef<MultiInstanceRequestBody>,
  params: MaybeRef<PostV7PostgresPaOverviewParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  multiInstanceRequestBody = unref(multiInstanceRequestBody);
  params = unref(params);

  return customAxiosInstance<MultiOverviewV7Response>(
    {
      url: `/api/v7/postgres/pa/overview`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: multiInstanceRequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7PostgresPaOverviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7PostgresPaOverview>>,
    TError,
    { data: BodyType<MultiInstanceRequestBody>; params: PostV7PostgresPaOverviewParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7PostgresPaOverview>>,
  TError,
  { data: BodyType<MultiInstanceRequestBody>; params: PostV7PostgresPaOverviewParams },
  TContext
> => {
  const mutationKey = ['postV7PostgresPaOverview'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7PostgresPaOverview>>,
    { data: BodyType<MultiInstanceRequestBody>; params: PostV7PostgresPaOverviewParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV7PostgresPaOverview(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7PostgresPaOverviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7PostgresPaOverview>>
>;
export type PostV7PostgresPaOverviewMutationBody = BodyType<MultiInstanceRequestBody>;
export type PostV7PostgresPaOverviewMutationError = ErrorType<unknown>;

/**
 * @summary [PostgreSQL] MultiView - Overview
 */
export const usePostV7PostgresPaOverview = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7PostgresPaOverview>>,
      TError,
      { data: BodyType<MultiInstanceRequestBody>; params: PostV7PostgresPaOverviewParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7PostgresPaOverview>>,
  TError,
  { data: BodyType<MultiInstanceRequestBody>; params: PostV7PostgresPaOverviewParams },
  TContext
> => {
  const mutationOptions = getPostV7PostgresPaOverviewMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getParameterHistory
 */
export const getV7PostgresPaParameterHistory = (
  params: MaybeRef<GetV7PostgresPaParameterHistoryParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ParameterResponse>(
    { url: `/api/v7/postgres/pa/parameter/history`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7PostgresPaParameterHistoryQueryKey = (
  params?: MaybeRef<GetV7PostgresPaParameterHistoryParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    'parameter',
    'history',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaParameterHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaParameterHistory>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresPaParameterHistoryParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresPaParameterHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaParameterHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7PostgresPaParameterHistory>>> = ({
    signal,
  }) => getV7PostgresPaParameterHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaParameterHistory>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaParameterHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaParameterHistory>>
>;
export type GetV7PostgresPaParameterHistoryQueryError = ErrorType<unknown>;

/**
 * @summary getParameterHistory
 */

export function useGetV7PostgresPaParameterHistory<
  TData = Awaited<ReturnType<typeof getV7PostgresPaParameterHistory>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresPaParameterHistoryParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresPaParameterHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaParameterHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary overview
 */
export const getV7PostgresPaRtmOverviewByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaRtmOverviewByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<OverViewV7Response>(
    {
      url: `/api/v7/postgres/pa/rtm/${instanceId}/overview`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaRtmOverviewByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaRtmOverviewByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    'rtm',
    instanceId,
    'overview',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaRtmOverviewByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaRtmOverviewByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaRtmOverviewByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaRtmOverviewByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaRtmOverviewByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaRtmOverviewByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaRtmOverviewByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaRtmOverviewByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaRtmOverviewByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaRtmOverviewByInstanceId>>
>;
export type GetV7PostgresPaRtmOverviewByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary overview
 */

export function useGetV7PostgresPaRtmOverviewByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaRtmOverviewByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaRtmOverviewByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaRtmOverviewByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaRtmOverviewByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getReplication
 */
export const getV7PostgresPaRtmReplicationByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaRtmReplicationByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ReplicationInfoV7Response>(
    {
      url: `/api/v7/postgres/pa/rtm/${instanceId}/replication`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaRtmReplicationByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaRtmReplicationByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    'rtm',
    instanceId,
    'replication',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaRtmReplicationByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaRtmReplicationByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaRtmReplicationByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaRtmReplicationByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaRtmReplicationByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaRtmReplicationByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaRtmReplicationByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaRtmReplicationByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaRtmReplicationByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaRtmReplicationByInstanceId>>
>;
export type GetV7PostgresPaRtmReplicationByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getReplication
 */

export function useGetV7PostgresPaRtmReplicationByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaRtmReplicationByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaRtmReplicationByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaRtmReplicationByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaRtmReplicationByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * PA > Postgresql > search session 기본뷰에서 Postgresql session 정보 조회.
 * @summary PA Postgresql search session
 */
export const getV7PostgresPaSessions = (
  params: MaybeRef<GetV7PostgresPaSessionsParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SessionSearchListV7Response>(
    { url: `/api/v7/postgres/pa/sessions`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7PostgresPaSessionsQueryKey = (
  params?: MaybeRef<GetV7PostgresPaSessionsParams>,
) => {
  return ['api', 'v7', 'postgres', 'pa', 'sessions', ...(params ? [params] : [])] as const;
};

export const getGetV7PostgresPaSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaSessions>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresPaSessionsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresPaSessions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaSessionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7PostgresPaSessions>>> = ({
    signal,
  }) => getV7PostgresPaSessions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaSessions>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaSessions>>
>;
export type GetV7PostgresPaSessionsQueryError = ErrorType<unknown>;

/**
 * @summary PA Postgresql search session
 */

export function useGetV7PostgresPaSessions<
  TData = Awaited<ReturnType<typeof getV7PostgresPaSessions>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresPaSessionsParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresPaSessions>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaSessionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary PA > Postgresql > Trend Analysis > 하단 그리드 > Long Active Backends 탭
 */
export const getV7PostgresPaTrendLongActivebackendsByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaTrendLongActivebackendsByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<LongActiveBackendV7Response>(
    {
      url: `/api/v7/postgres/pa/trend/${instanceId}/long-activebackends`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaTrendLongActivebackendsByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTrendLongActivebackendsByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    'trend',
    instanceId,
    'long-activebackends',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaTrendLongActivebackendsByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaTrendLongActivebackendsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaTrendLongActivebackendsByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTrendLongActivebackendsByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaTrendLongActivebackendsByInstanceIdQueryKey(
    instanceId,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaTrendLongActivebackendsByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaTrendLongActivebackendsByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaTrendLongActivebackendsByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaTrendLongActivebackendsByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaTrendLongActivebackendsByInstanceId>>
>;
export type GetV7PostgresPaTrendLongActivebackendsByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary PA > Postgresql > Trend Analysis > 하단 그리드 > Long Active Backends 탭
 */

export function useGetV7PostgresPaTrendLongActivebackendsByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaTrendLongActivebackendsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaTrendLongActivebackendsByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTrendLongActivebackendsByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaTrendLongActivebackendsByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Postgresql] : PA > Trend Analysis > Top Object
 */
export const getV7PostgresPaTrendTopObjectSortByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaTrendTopObjectSortByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TrendTopObjectListV7Response>(
    {
      url: `/api/v7/postgres/pa/trend/${instanceId}/top-object/sort`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaTrendTopObjectSortByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTrendTopObjectSortByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    'trend',
    instanceId,
    'top-object',
    'sort',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaTrendTopObjectSortByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaTrendTopObjectSortByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaTrendTopObjectSortByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTrendTopObjectSortByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaTrendTopObjectSortByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaTrendTopObjectSortByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaTrendTopObjectSortByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaTrendTopObjectSortByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaTrendTopObjectSortByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaTrendTopObjectSortByInstanceId>>
>;
export type GetV7PostgresPaTrendTopObjectSortByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql] : PA > Trend Analysis > Top Object
 */

export function useGetV7PostgresPaTrendTopObjectSortByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaTrendTopObjectSortByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaTrendTopObjectSortByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTrendTopObjectSortByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaTrendTopObjectSortByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary PA > Postgresql > Trend Analysis > 하단 그리드 > Vacuum 1분 범위 초(sec) 목록 조회
 */
export const getV7PostgresPaVacuumingBackendsSecond = (
  params: MaybeRef<GetV7PostgresPaVacuumingBackendsSecondParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseInt>(
    {
      url: `/api/v7/postgres/pa/vacuuming-backends-second`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaVacuumingBackendsSecondQueryKey = (
  params?: MaybeRef<GetV7PostgresPaVacuumingBackendsSecondParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    'vacuuming-backends-second',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaVacuumingBackendsSecondQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsSecond>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresPaVacuumingBackendsSecondParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsSecond>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaVacuumingBackendsSecondQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsSecond>>
  > = ({ signal }) => getV7PostgresPaVacuumingBackendsSecond(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsSecond>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaVacuumingBackendsSecondQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsSecond>>
>;
export type GetV7PostgresPaVacuumingBackendsSecondQueryError = ErrorType<unknown>;

/**
 * @summary PA > Postgresql > Trend Analysis > 하단 그리드 > Vacuum 1분 범위 초(sec) 목록 조회
 */

export function useGetV7PostgresPaVacuumingBackendsSecond<
  TData = Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsSecond>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresPaVacuumingBackendsSecondParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsSecond>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaVacuumingBackendsSecondQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary killSession
 */
export const postV7PostgresPaActivebackendKillSessionByInstanceId = (
  params: MaybeRef<PostV7PostgresPaActivebackendKillSessionByInstanceIdParams>,
  instanceId: MaybeRef<string> = '276',
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);
  instanceId = unref(instanceId);

  return customAxiosInstance<string>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/activebackend/kill-session`,
      method: 'POST',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7PostgresPaActivebackendKillSessionByInstanceIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7PostgresPaActivebackendKillSessionByInstanceId>>,
    TError,
    { params: PostV7PostgresPaActivebackendKillSessionByInstanceIdParams; instanceId?: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7PostgresPaActivebackendKillSessionByInstanceId>>,
  TError,
  { params: PostV7PostgresPaActivebackendKillSessionByInstanceIdParams; instanceId?: string },
  TContext
> => {
  const mutationKey = ['postV7PostgresPaActivebackendKillSessionByInstanceId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7PostgresPaActivebackendKillSessionByInstanceId>>,
    { params: PostV7PostgresPaActivebackendKillSessionByInstanceIdParams; instanceId?: string }
  > = (props) => {
    const { params, instanceId } = props ?? {};

    return postV7PostgresPaActivebackendKillSessionByInstanceId(params, instanceId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7PostgresPaActivebackendKillSessionByInstanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7PostgresPaActivebackendKillSessionByInstanceId>>
>;

export type PostV7PostgresPaActivebackendKillSessionByInstanceIdMutationError = ErrorType<unknown>;

/**
 * @summary killSession
 */
export const usePostV7PostgresPaActivebackendKillSessionByInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7PostgresPaActivebackendKillSessionByInstanceId>>,
      TError,
      { params: PostV7PostgresPaActivebackendKillSessionByInstanceIdParams; instanceId?: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7PostgresPaActivebackendKillSessionByInstanceId>>,
  TError,
  { params: PostV7PostgresPaActivebackendKillSessionByInstanceIdParams; instanceId?: string },
  TContext
> => {
  const mutationOptions =
    getPostV7PostgresPaActivebackendKillSessionByInstanceIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary [Postgresql]: Single View > Additional Information
 */
export const getV7PostgresPaAdditionalInfoByInstanceId = (
  instanceId: MaybeRef<string> = '21eb47db-9fa9-45d3-9de6-5b53b868a855',
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<AdditionalInfoV7Response>(
    { url: `/api/v7/postgres/pa/${instanceId}/additional-info`, method: 'GET', signal },
    options,
  );
};

export const getGetV7PostgresPaAdditionalInfoByInstanceIdQueryKey = (
  instanceId: MaybeRef<string> = '21eb47db-9fa9-45d3-9de6-5b53b868a855',
) => {
  return ['api', 'v7', 'postgres', 'pa', instanceId, 'additional-info'] as const;
};

export const getGetV7PostgresPaAdditionalInfoByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaAdditionalInfoByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string> = '21eb47db-9fa9-45d3-9de6-5b53b868a855',
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaAdditionalInfoByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaAdditionalInfoByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaAdditionalInfoByInstanceId>>
  > = ({ signal }) => getV7PostgresPaAdditionalInfoByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaAdditionalInfoByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaAdditionalInfoByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaAdditionalInfoByInstanceId>>
>;
export type GetV7PostgresPaAdditionalInfoByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql]: Single View > Additional Information
 */

export function useGetV7PostgresPaAdditionalInfoByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaAdditionalInfoByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string> = '21eb47db-9fa9-45d3-9de6-5b53b868a855',
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaAdditionalInfoByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaAdditionalInfoByInstanceIdQueryOptions(
    instanceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getAdminReference
 */
export const getV7PostgresPaAdminReferenceByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaAdminReferenceByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<AdminRefVacuumV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/admin-reference`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaAdminReferenceByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaAdminReferenceByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'admin-reference',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaAdminReferenceByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaAdminReferenceByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaAdminReferenceByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaAdminReferenceByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaAdminReferenceByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaAdminReferenceByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaAdminReferenceByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaAdminReferenceByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaAdminReferenceByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaAdminReferenceByInstanceId>>
>;
export type GetV7PostgresPaAdminReferenceByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getAdminReference
 */

export function useGetV7PostgresPaAdminReferenceByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaAdminReferenceByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaAdminReferenceByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaAdminReferenceByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaAdminReferenceByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getCheckpoint
 */
export const getV7PostgresPaCheckpointByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaCheckpointByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<CheckPointV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/checkpoint`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaCheckpointByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaCheckpointByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'checkpoint',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaCheckpointByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaCheckpointByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaCheckpointByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaCheckpointByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaCheckpointByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaCheckpointByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaCheckpointByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaCheckpointByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaCheckpointByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaCheckpointByInstanceId>>
>;
export type GetV7PostgresPaCheckpointByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getCheckpoint
 */

export function useGetV7PostgresPaCheckpointByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaCheckpointByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaCheckpointByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaCheckpointByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaCheckpointByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Postgresql]: Single View Function Detail 팝업
 */
export const getV7PostgresPaFunctionsByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaFunctionsByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<FunctionDetailV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/functions`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaFunctionsByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaFunctionsByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'functions',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaFunctionsByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaFunctionsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaFunctionsByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaFunctionsByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaFunctionsByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaFunctionsByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaFunctionsByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaFunctionsByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaFunctionsByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaFunctionsByInstanceId>>
>;
export type GetV7PostgresPaFunctionsByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql]: Single View Function Detail 팝업
 */

export function useGetV7PostgresPaFunctionsByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaFunctionsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaFunctionsByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaFunctionsByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaFunctionsByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getFunctionSource
 */
export const getV7PostgresPaFunctionsFuncsrcByInstanceId = (
  params: MaybeRef<GetV7PostgresPaFunctionsFuncsrcByInstanceIdParams>,
  instanceId: MaybeRef<string> = '2078',
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);
  instanceId = unref(instanceId);

  return customAxiosInstance<FunctionSrcV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/functions/funcsrc`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaFunctionsFuncsrcByInstanceIdQueryKey = (
  params?: MaybeRef<GetV7PostgresPaFunctionsFuncsrcByInstanceIdParams>,
  instanceId: MaybeRef<string> = '2078',
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'functions',
    'funcsrc',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaFunctionsFuncsrcByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaFunctionsFuncsrcByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresPaFunctionsFuncsrcByInstanceIdParams>,
  instanceId: MaybeRef<string> = '2078',
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaFunctionsFuncsrcByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaFunctionsFuncsrcByInstanceIdQueryKey(params, instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaFunctionsFuncsrcByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaFunctionsFuncsrcByInstanceId(params, instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaFunctionsFuncsrcByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaFunctionsFuncsrcByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaFunctionsFuncsrcByInstanceId>>
>;
export type GetV7PostgresPaFunctionsFuncsrcByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getFunctionSource
 */

export function useGetV7PostgresPaFunctionsFuncsrcByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaFunctionsFuncsrcByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresPaFunctionsFuncsrcByInstanceIdParams>,
  instanceId: MaybeRef<string> = '2078',
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaFunctionsFuncsrcByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaFunctionsFuncsrcByInstanceIdQueryOptions(
    params,
    instanceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getObjectNameList
 */
export const getV7PostgresPaObjectNamesByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjectNamesByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ObjectTrendV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/object-names`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaObjectNamesByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjectNamesByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'object-names',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaObjectNamesByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjectNamesByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjectNamesByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjectNamesByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaObjectNamesByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaObjectNamesByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaObjectNamesByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaObjectNamesByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaObjectNamesByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaObjectNamesByInstanceId>>
>;
export type GetV7PostgresPaObjectNamesByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getObjectNameList
 */

export function useGetV7PostgresPaObjectNamesByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjectNamesByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjectNamesByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjectNamesByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaObjectNamesByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary topObjectIndexScan
 */
export const getV7PostgresPaObjectRatioByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjectRatioByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ObjectScanRatioV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/object-ratio`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaObjectRatioByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjectRatioByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'object-ratio',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaObjectRatioByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjectRatioByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjectRatioByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjectRatioByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaObjectRatioByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaObjectRatioByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaObjectRatioByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaObjectRatioByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaObjectRatioByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaObjectRatioByInstanceId>>
>;
export type GetV7PostgresPaObjectRatioByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary topObjectIndexScan
 */

export function useGetV7PostgresPaObjectRatioByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjectRatioByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjectRatioByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjectRatioByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaObjectRatioByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary PA > Postgresql > Object Size > 중단 그리드 > 데이터베이스 크기 정보
 */
export const getV7PostgresPaObjectInfoByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjectInfoByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ObjectInfoV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/object/info`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaObjectInfoByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjectInfoByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'object',
    'info',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaObjectInfoByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjectInfoByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjectInfoByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjectInfoByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaObjectInfoByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaObjectInfoByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaObjectInfoByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaObjectInfoByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaObjectInfoByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaObjectInfoByInstanceId>>
>;
export type GetV7PostgresPaObjectInfoByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary PA > Postgresql > Object Size > 중단 그리드 > 데이터베이스 크기 정보
 */

export function useGetV7PostgresPaObjectInfoByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjectInfoByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjectInfoByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjectInfoByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaObjectInfoByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 선택된 로우(Total/DB) 에 따라서 받는 파라미터가 다르다.Total: instanceId = 클러스터 아이디, datname  = null | DB: instanceId = 특정 db 아이디, datname = 선택 로우 DatabaseName
 * @summary PA > Postgresql > Object Size > 하단 그리드 > 상위 30 오브젝트
 */
export const getV7PostgresPaObjectTopByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjectTopByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopObjectV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/object/top`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaObjectTopByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjectTopByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'object',
    'top',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaObjectTopByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjectTopByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjectTopByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjectTopByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaObjectTopByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaObjectTopByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaObjectTopByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaObjectTopByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaObjectTopByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaObjectTopByInstanceId>>
>;
export type GetV7PostgresPaObjectTopByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary PA > Postgresql > Object Size > 하단 그리드 > 상위 30 오브젝트
 */

export function useGetV7PostgresPaObjectTopByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjectTopByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjectTopByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjectTopByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaObjectTopByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getObjectSizeTrend
 */
export const getV7PostgresPaObjectTrendByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjectTrendByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ObjectTrendV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/object/trend`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaObjectTrendByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjectTrendByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'object',
    'trend',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaObjectTrendByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjectTrendByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjectTrendByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjectTrendByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaObjectTrendByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaObjectTrendByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaObjectTrendByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaObjectTrendByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaObjectTrendByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaObjectTrendByInstanceId>>
>;
export type GetV7PostgresPaObjectTrendByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getObjectSizeTrend
 */

export function useGetV7PostgresPaObjectTrendByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjectTrendByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjectTrendByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjectTrendByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaObjectTrendByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Postgresql]: Single View Top object(우측 영역) Detail 팝업, Vacuum Detail 팝업
 */
export const getV7PostgresPaObjects10minAgeByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minAgeByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopObjectListAgeV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/objects-10min/age`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaObjects10minAgeByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjects10minAgeByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'objects-10min',
    'age',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaObjects10minAgeByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjects10minAgeByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minAgeByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjects10minAgeByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaObjects10minAgeByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaObjects10minAgeByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaObjects10minAgeByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaObjects10minAgeByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaObjects10minAgeByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaObjects10minAgeByInstanceId>>
>;
export type GetV7PostgresPaObjects10minAgeByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql]: Single View Top object(우측 영역) Detail 팝업, Vacuum Detail 팝업
 */

export function useGetV7PostgresPaObjects10minAgeByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjects10minAgeByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minAgeByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjects10minAgeByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaObjects10minAgeByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Postgresql]: Single View Top object Detail 팝업 > analyze-time
 */
export const getV7PostgresPaObjects10minAnalyzeTimeByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minAnalyzeTimeByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopObjectAnalyzeTimeV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/objects-10min/analyze-time`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaObjects10minAnalyzeTimeByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjects10minAnalyzeTimeByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'objects-10min',
    'analyze-time',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaObjects10minAnalyzeTimeByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjects10minAnalyzeTimeByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minAnalyzeTimeByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjects10minAnalyzeTimeByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaObjects10minAnalyzeTimeByInstanceIdQueryKey(
    instanceId,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaObjects10minAnalyzeTimeByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaObjects10minAnalyzeTimeByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaObjects10minAnalyzeTimeByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaObjects10minAnalyzeTimeByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaObjects10minAnalyzeTimeByInstanceId>>
>;
export type GetV7PostgresPaObjects10minAnalyzeTimeByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql]: Single View Top object Detail 팝업 > analyze-time
 */

export function useGetV7PostgresPaObjects10minAnalyzeTimeByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjects10minAnalyzeTimeByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minAnalyzeTimeByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjects10minAnalyzeTimeByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaObjects10minAnalyzeTimeByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Postgresql]: Single View Top object Detail 팝업 > dead-tuple
 */
export const getV7PostgresPaObjects10minDeadTupleByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minDeadTupleByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopObjectListDeadTupleV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/objects-10min/dead-tuple`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaObjects10minDeadTupleByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjects10minDeadTupleByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'objects-10min',
    'dead-tuple',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaObjects10minDeadTupleByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjects10minDeadTupleByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minDeadTupleByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjects10minDeadTupleByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaObjects10minDeadTupleByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaObjects10minDeadTupleByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaObjects10minDeadTupleByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaObjects10minDeadTupleByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaObjects10minDeadTupleByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaObjects10minDeadTupleByInstanceId>>
>;
export type GetV7PostgresPaObjects10minDeadTupleByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql]: Single View Top object Detail 팝업 > dead-tuple
 */

export function useGetV7PostgresPaObjects10minDeadTupleByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjects10minDeadTupleByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minDeadTupleByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjects10minDeadTupleByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaObjects10minDeadTupleByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Postgresql]: Single View Top object Detail 팝업 > scan-count
 */
export const getV7PostgresPaObjects10minScanCountByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minScanCountByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopObjectListScanCountV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/objects-10min/scan-count`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaObjects10minScanCountByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjects10minScanCountByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'objects-10min',
    'scan-count',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaObjects10minScanCountByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanCountByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minScanCountByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanCountByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaObjects10minScanCountByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanCountByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaObjects10minScanCountByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanCountByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaObjects10minScanCountByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanCountByInstanceId>>
>;
export type GetV7PostgresPaObjects10minScanCountByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql]: Single View Top object Detail 팝업 > scan-count
 */

export function useGetV7PostgresPaObjects10minScanCountByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanCountByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minScanCountByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanCountByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaObjects10minScanCountByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Postgresql]: Single View, Top object(좌측 영역) Index vs Table Detail 팝업
 */
export const getV7PostgresPaObjects10minScanRatioByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minScanRatioByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopObjectTableScanRatioV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/objects-10min/scan-ratio`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaObjects10minScanRatioByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjects10minScanRatioByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'objects-10min',
    'scan-ratio',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaObjects10minScanRatioByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanRatioByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minScanRatioByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanRatioByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaObjects10minScanRatioByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanRatioByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaObjects10minScanRatioByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanRatioByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaObjects10minScanRatioByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanRatioByInstanceId>>
>;
export type GetV7PostgresPaObjects10minScanRatioByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql]: Single View, Top object(좌측 영역) Index vs Table Detail 팝업
 */

export function useGetV7PostgresPaObjects10minScanRatioByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanRatioByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minScanRatioByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjects10minScanRatioByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaObjects10minScanRatioByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Postgresql]: Single View > Additional Info > Top Tablespace Size Detail 팝업
 */
export const getV7PostgresPaObjects10minTablespaceSizeByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minTablespaceSizeByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopObjectListTableSpaceV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/objects-10min/tablespace-size`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaObjects10minTablespaceSizeByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaObjects10minTablespaceSizeByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'objects-10min',
    'tablespace-size',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaObjects10minTablespaceSizeByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjects10minTablespaceSizeByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minTablespaceSizeByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjects10minTablespaceSizeByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaObjects10minTablespaceSizeByInstanceIdQueryKey(
    instanceId,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaObjects10minTablespaceSizeByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaObjects10minTablespaceSizeByInstanceId(
      instanceId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaObjects10minTablespaceSizeByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaObjects10minTablespaceSizeByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaObjects10minTablespaceSizeByInstanceId>>
>;
export type GetV7PostgresPaObjects10minTablespaceSizeByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql]: Single View > Additional Info > Top Tablespace Size Detail 팝업
 */

export function useGetV7PostgresPaObjects10minTablespaceSizeByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaObjects10minTablespaceSizeByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaObjects10minTablespaceSizeByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaObjects10minTablespaceSizeByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaObjects10minTablespaceSizeByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary PostgreSQL - 파라미터 디테일 (Information과 History 분리)
 */
export const getV7PostgresPaParameterDetailByInstanceIdAndParameterName = (
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaParameterDetailByInstanceIdAndParameterNameParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  parameterName = unref(parameterName);
  params = unref(params);

  return customAxiosInstance<ApiResponsePostgresqlParameterDetailRs>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/parameter/${parameterName}/detail`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaParameterDetailByInstanceIdAndParameterNameQueryKey = (
  instanceId?: MaybeRef<string>,
  parameterName?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaParameterDetailByInstanceIdAndParameterNameParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'parameter',
    parameterName,
    'detail',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaParameterDetailByInstanceIdAndParameterNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaParameterDetailByInstanceIdAndParameterName>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaParameterDetailByInstanceIdAndParameterNameParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaParameterDetailByInstanceIdAndParameterName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaParameterDetailByInstanceIdAndParameterNameQueryKey(
    instanceId,
    parameterName,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaParameterDetailByInstanceIdAndParameterName>>
  > = ({ signal }) =>
    getV7PostgresPaParameterDetailByInstanceIdAndParameterName(
      instanceId,
      parameterName,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(parameterName))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaParameterDetailByInstanceIdAndParameterName>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaParameterDetailByInstanceIdAndParameterNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaParameterDetailByInstanceIdAndParameterName>>
>;
export type GetV7PostgresPaParameterDetailByInstanceIdAndParameterNameQueryError =
  ErrorType<unknown>;

/**
 * @summary PostgreSQL - 파라미터 디테일 (Information과 History 분리)
 */

export function useGetV7PostgresPaParameterDetailByInstanceIdAndParameterName<
  TData = Awaited<ReturnType<typeof getV7PostgresPaParameterDetailByInstanceIdAndParameterName>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7PostgresPaParameterDetailByInstanceIdAndParameterNameParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaParameterDetailByInstanceIdAndParameterName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaParameterDetailByInstanceIdAndParameterNameQueryOptions(
    instanceId,
    parameterName,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getTopDiffStatistics
 */
export const getV7PostgresPaTopDiffStatisticsByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopDiffStatisticsByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopDiffStatisticsV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/top-diff-statistics`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaTopDiffStatisticsByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopDiffStatisticsByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'top-diff-statistics',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaTopDiffStatisticsByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaTopDiffStatisticsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopDiffStatisticsByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTopDiffStatisticsByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaTopDiffStatisticsByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaTopDiffStatisticsByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaTopDiffStatisticsByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaTopDiffStatisticsByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaTopDiffStatisticsByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaTopDiffStatisticsByInstanceId>>
>;
export type GetV7PostgresPaTopDiffStatisticsByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getTopDiffStatistics
 */

export function useGetV7PostgresPaTopDiffStatisticsByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaTopDiffStatisticsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopDiffStatisticsByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTopDiffStatisticsByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaTopDiffStatisticsByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getTopFunction
 */
export const getV7PostgresPaTopFunctionCallByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopFunctionCallByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopFunctionV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/top-function-call`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaTopFunctionCallByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopFunctionCallByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'top-function-call',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaTopFunctionCallByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaTopFunctionCallByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopFunctionCallByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTopFunctionCallByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaTopFunctionCallByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaTopFunctionCallByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaTopFunctionCallByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaTopFunctionCallByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaTopFunctionCallByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaTopFunctionCallByInstanceId>>
>;
export type GetV7PostgresPaTopFunctionCallByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getTopFunction
 */

export function useGetV7PostgresPaTopFunctionCallByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaTopFunctionCallByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopFunctionCallByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTopFunctionCallByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaTopFunctionCallByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getTopScanObjectV2
 */
export const getV7PostgresPaTopObjectScanByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopObjectScanByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopObjectScanListV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/top-object-scan`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaTopObjectScanByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopObjectScanByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'top-object-scan',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaTopObjectScanByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaTopObjectScanByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopObjectScanByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTopObjectScanByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaTopObjectScanByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaTopObjectScanByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaTopObjectScanByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaTopObjectScanByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaTopObjectScanByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaTopObjectScanByInstanceId>>
>;
export type GetV7PostgresPaTopObjectScanByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getTopScanObjectV2
 */

export function useGetV7PostgresPaTopObjectScanByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaTopObjectScanByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopObjectScanByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTopObjectScanByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaTopObjectScanByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getTopWaitEvent
 */
export const getV7PostgresPaTopSessionEventByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopSessionEventByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopSessionEventV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/top-session-event`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaTopSessionEventByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopSessionEventByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'top-session-event',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaTopSessionEventByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaTopSessionEventByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopSessionEventByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTopSessionEventByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaTopSessionEventByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaTopSessionEventByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaTopSessionEventByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaTopSessionEventByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaTopSessionEventByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaTopSessionEventByInstanceId>>
>;
export type GetV7PostgresPaTopSessionEventByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getTopWaitEvent
 */

export function useGetV7PostgresPaTopSessionEventByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaTopSessionEventByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopSessionEventByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTopSessionEventByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaTopSessionEventByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getTopSessionSql
 */
export const getV7PostgresPaTopSessionSqlByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopSessionSqlByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<TopSessionSqlV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/top-session-sql`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaTopSessionSqlByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopSessionSqlByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'top-session-sql',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaTopSessionSqlByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaTopSessionSqlByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopSessionSqlByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTopSessionSqlByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaTopSessionSqlByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaTopSessionSqlByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaTopSessionSqlByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaTopSessionSqlByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaTopSessionSqlByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaTopSessionSqlByInstanceId>>
>;
export type GetV7PostgresPaTopSessionSqlByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getTopSessionSql
 */

export function useGetV7PostgresPaTopSessionSqlByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaTopSessionSqlByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaTopSessionSqlByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaTopSessionSqlByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaTopSessionSqlByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getVacuumInfo
 */
export const getV7PostgresPaVacuumByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaVacuumByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<VacuumV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/vacuum`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaVacuumByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaVacuumByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'vacuum',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaVacuumByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaVacuumByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaVacuumByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresPaVacuumByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaVacuumByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7PostgresPaVacuumByInstanceId>>> = ({
    signal,
  }) => getV7PostgresPaVacuumByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaVacuumByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaVacuumByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaVacuumByInstanceId>>
>;
export type GetV7PostgresPaVacuumByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getVacuumInfo
 */

export function useGetV7PostgresPaVacuumByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaVacuumByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaVacuumByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresPaVacuumByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaVacuumByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [Postgresql]: PA(Trend) 하단 그리드 > Vacuum 탭, Single View > Vacuuming Process 차트 Detail 팝업
 */
export const getV7PostgresPaVacuumingBackendsByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaVacuumingBackendsByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<VacuumingBackendV7Response>(
    {
      url: `/api/v7/postgres/pa/${instanceId}/vacuuming-backends`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresPaVacuumingBackendsByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaVacuumingBackendsByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'pa',
    instanceId,
    'vacuuming-backends',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresPaVacuumingBackendsByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaVacuumingBackendsByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresPaVacuumingBackendsByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsByInstanceId>>
  > = ({ signal }) =>
    getV7PostgresPaVacuumingBackendsByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresPaVacuumingBackendsByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsByInstanceId>>
>;
export type GetV7PostgresPaVacuumingBackendsByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql]: PA(Trend) 하단 그리드 > Vacuum 탭, Single View > Vacuuming Process 차트 Detail 팝업
 */

export function useGetV7PostgresPaVacuumingBackendsByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7PostgresPaVacuumingBackendsByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresPaVacuumingBackendsByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresPaVacuumingBackendsByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getParameterList
 */
export const getV7PostgresParameterByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<LastParameterResponse>(
    { url: `/api/v7/postgres/parameter/${instanceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7PostgresParameterByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v7', 'postgres', 'parameter', instanceId] as const;
};

export const getGetV7PostgresParameterByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresParameterByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresParameterByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresParameterByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7PostgresParameterByInstanceId>>> = ({
    signal,
  }) => getV7PostgresParameterByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresParameterByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7PostgresParameterByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresParameterByInstanceId>>
>;
export type GetV7PostgresParameterByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary getParameterList
 */

export function useGetV7PostgresParameterByInstanceId<
  TData = Awaited<ReturnType<typeof getV7PostgresParameterByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresParameterByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresParameterByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 선택된 database 목록으로 슬로우 쿼리 조회한다.
 * @summary [PG]: Single View > Slow Queries & 드래그시 SQL Elapsed List 팝업 내 엑셀 추출(isFullText=ture로 요청)
 */
export const getV7PostgresSingleViewDatabaseSlowquery = (
  params: MaybeRef<GetV7PostgresSingleViewDatabaseSlowqueryParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<SlowQueryListV7Response>(
    {
      url: `/api/v7/postgres/single-view/database-slowquery`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7PostgresSingleViewDatabaseSlowqueryQueryKey = (
  params?: MaybeRef<GetV7PostgresSingleViewDatabaseSlowqueryParams>,
) => {
  return [
    'api',
    'v7',
    'postgres',
    'single-view',
    'database-slowquery',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7PostgresSingleViewDatabaseSlowqueryQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresSingleViewDatabaseSlowquery>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresSingleViewDatabaseSlowqueryParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresSingleViewDatabaseSlowquery>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresSingleViewDatabaseSlowqueryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7PostgresSingleViewDatabaseSlowquery>>
  > = ({ signal }) => getV7PostgresSingleViewDatabaseSlowquery(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresSingleViewDatabaseSlowquery>>,
    TError,
    TData
  >;
};

export type GetV7PostgresSingleViewDatabaseSlowqueryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresSingleViewDatabaseSlowquery>>
>;
export type GetV7PostgresSingleViewDatabaseSlowqueryQueryError = ErrorType<unknown>;

/**
 * @summary [PG]: Single View > Slow Queries & 드래그시 SQL Elapsed List 팝업 내 엑셀 추출(isFullText=ture로 요청)
 */

export function useGetV7PostgresSingleViewDatabaseSlowquery<
  TData = Awaited<ReturnType<typeof getV7PostgresSingleViewDatabaseSlowquery>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresSingleViewDatabaseSlowqueryParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7PostgresSingleViewDatabaseSlowquery>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresSingleViewDatabaseSlowqueryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * isDefaultPlan 파라미터에 따라 노말라이즈드쿼리, 리터럴쿼리에 대한 플랜 조회를 달리합니다. 만약 isDefaultPlan=false 요청이더라도 리터럴쿼리텍스트를 찾을 수 없으면 노말라이즈드 쿼리 플랜 결과를 리턴합니다.
 * @summary PostgreSQL - 플랜 조회(공통)
 */
export const postV7PostgresSqlPlanByInstanceId = (
  instanceId: MaybeRef<string>,
  sqlPlanOptionRequest: MaybeRef<SqlPlanOptionRequest>,
  params: MaybeRef<PostV7PostgresSqlPlanByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  sqlPlanOptionRequest = unref(sqlPlanOptionRequest);
  params = unref(params);

  return customAxiosInstance<SqlPlanV7Response>(
    {
      url: `/api/v7/postgres/sql-plan/${instanceId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sqlPlanOptionRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7PostgresSqlPlanByInstanceIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7PostgresSqlPlanByInstanceId>>,
    TError,
    {
      instanceId: string;
      data: BodyType<SqlPlanOptionRequest>;
      params: PostV7PostgresSqlPlanByInstanceIdParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7PostgresSqlPlanByInstanceId>>,
  TError,
  {
    instanceId: string;
    data: BodyType<SqlPlanOptionRequest>;
    params: PostV7PostgresSqlPlanByInstanceIdParams;
  },
  TContext
> => {
  const mutationKey = ['postV7PostgresSqlPlanByInstanceId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7PostgresSqlPlanByInstanceId>>,
    {
      instanceId: string;
      data: BodyType<SqlPlanOptionRequest>;
      params: PostV7PostgresSqlPlanByInstanceIdParams;
    }
  > = (props) => {
    const { instanceId, data, params } = props ?? {};

    return postV7PostgresSqlPlanByInstanceId(instanceId, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7PostgresSqlPlanByInstanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7PostgresSqlPlanByInstanceId>>
>;
export type PostV7PostgresSqlPlanByInstanceIdMutationBody = BodyType<SqlPlanOptionRequest>;
export type PostV7PostgresSqlPlanByInstanceIdMutationError = ErrorType<unknown>;

/**
 * @summary PostgreSQL - 플랜 조회(공통)
 */
export const usePostV7PostgresSqlPlanByInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7PostgresSqlPlanByInstanceId>>,
      TError,
      {
        instanceId: string;
        data: BodyType<SqlPlanOptionRequest>;
        params: PostV7PostgresSqlPlanByInstanceIdParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7PostgresSqlPlanByInstanceId>>,
  TError,
  {
    instanceId: string;
    data: BodyType<SqlPlanOptionRequest>;
    params: PostV7PostgresSqlPlanByInstanceIdParams;
  },
  TContext
> => {
  const mutationOptions = getPostV7PostgresSqlPlanByInstanceIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 세션 디테일 연계에 필요한 인자 조회 용도
 * @summary [Postgresql]: Multi View Top Transaction Info
 */
export const getV7PostgresTopTrxInfo = (
  params: MaybeRef<GetV7PostgresTopTrxInfoParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseTopTransactionInfoResponse>(
    { url: `/api/v7/postgres/top-trx-info`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7PostgresTopTrxInfoQueryKey = (
  params?: MaybeRef<GetV7PostgresTopTrxInfoParams>,
) => {
  return ['api', 'v7', 'postgres', 'top-trx-info', ...(params ? [params] : [])] as const;
};

export const getGetV7PostgresTopTrxInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7PostgresTopTrxInfo>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresTopTrxInfoParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresTopTrxInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7PostgresTopTrxInfoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7PostgresTopTrxInfo>>> = ({
    signal,
  }) => getV7PostgresTopTrxInfo(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7PostgresTopTrxInfo>>,
    TError,
    TData
  >;
};

export type GetV7PostgresTopTrxInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7PostgresTopTrxInfo>>
>;
export type GetV7PostgresTopTrxInfoQueryError = ErrorType<unknown>;

/**
 * @summary [Postgresql]: Multi View Top Transaction Info
 */

export function useGetV7PostgresTopTrxInfo<
  TData = Awaited<ReturnType<typeof getV7PostgresTopTrxInfo>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7PostgresTopTrxInfoParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7PostgresTopTrxInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7PostgresTopTrxInfoQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
